import { signalHandOff } from "../hooks/useHandOffSignal";
import { APPLIED_ON_TAKE, reportAskAction } from "./askReturn";
/**
 * A form Ask filled in that lives inside a record page (e.g. a movement's
 * incident), handed from the assistant to that page: the page takes it once,
 * adds it unsaved and the person saves. Held in memory only — a reload drops it.
 */
const pending = new Map<string, Record<string, unknown>>();

const keyOf = (kind: string, id: number | null | undefined) => `${kind}:${id ?? ""}`;

export const handOverDraft = (kind: string, id: number, values: Record<string, unknown>): void => {
    pending.set(keyOf(kind, id), values);
    // a page already on screen takes it now
    signalHandOff();
};

/** The draft waiting for this record, once (it's cleared when taken). */
export const takeDraft = (kind: string, id: number | null | undefined): Record<string, unknown> | null => {
    const key = keyOf(kind, id);
    const values = pending.get(key) ?? null;
    pending.delete(key);
    // a draft the page applies as it takes it: Ask's action is now "filled" (the form waits for Save)
    if (values && APPLIED_ON_TAKE.has(kind)) reportAskAction("filled");
    return values;
};
